export default __webpack_public_path__ + "static/pp-trimmed-112e6af58c8b764b9d2b1913b43016e0.mp4";